import api from ".";

const path = "/admin/users";

const apiUsers = api(path, {});

export default apiUsers;
